<template>
  <div>
    <v-col cols="12" id="TopBoardCompany" class="px-0 pb-0 sm-pb-3">
      <TopBoardCompany
        :screenWidth="screenWidth"
        :isMobile="isMobile"
        :numOfEmployees="numOfEmployees"
        :industry="industry"
        :logo="logo"
        :images="images"
        :name="companyName"
        :numOfBranches="numOfBranches"
      />
    </v-col>

    <div class="section_inner">
      <!-- <ArticleBreadcrumbs :items="seodata.breadcrumbs" class="pt-0" v-show="seodata.breadcrumbs.length>1"/> -->
      <!-- temporary until using microservice data -->
      <ArticleBreadcrumbsLegacy :items="seo" class="pt-0" v-show="seo.length>1" />
      <v-row>
        <v-col class="company-carousel">
          <div id="company-carousel">
            <v-carousel
              :cycle="true"
              :hide-delimiters="Object.keys(images).length < 2 || isMobile"
              :show-arrows="false"
              light
              hide-delimiter-background
              :height="isMobile ? 'auto' : 400"
            >
              <v-carousel-item v-for="(slide, i) in images" :key="i" cover>
                <v-sheet>
                  <v-img :src="slide" class="company-image-slide" />
                </v-sheet>
              </v-carousel-item>
            </v-carousel>
          </div>
        </v-col>
      </v-row>
      <v-row class="flex-column ma-0 px-0">
        <v-col id="company-about" class="pa-0">
          <v-row class="ma-0" justify="center">
            <v-col class="py-md-4 py-0" cols="12" :md="displayOnMap? '6' : '12'" :sm="displayOnMap? '6' : '12'">
              <AboutCompany
                v-if="displayAboutCompanySection"
                :description="description"
                :companyName="companyName"
                :address="address"
                :latitude="latitude"
                :longitude="longitude"
                id="description"
                :isMobile="isMobile"
              />
            </v-col>

            <v-col class="py-md-4 px-0 pa-0" cols="12" md="6" sm="6" v-if="displayOnMap">
              <GoogleMap
                :address="address"
                :destinationLatitude="latitude"
                :destinationLongitude="longitude"
              />
            </v-col>

          </v-row>
        </v-col>

        <v-col cols="12" class="px-0 py-md-4 py-0" id="reason-to-join">
          <ReasonsToJoin
            v-if="displayCompanyBenefits"
            :isMobile="isMobile"
            :benefits="benefits"
            :CustomBenefit="CustomBenefit"
            :testimonials="testimonials"
            :companyName="companyName"
          />
        </v-col>

        <v-col class="px-0 py-md-4 py-0" v-if="!isEmptyArr(testimonials)">
          <WorkersSayings :companyTestimpnials="testimonials" />
        </v-col>

        <v-col py-0>
          <JobsInCompany
            v-if="displayJobsSection"
            :jobs="jobsList"
            :isMobile="isMobile"
            :companyName="companyName"
            :companyDisplayUrl="companyDisplayUrl"
            :companyCode="companyCode"
            :jobsInCompany="jobs.length"
            :categories="categories"
          />
          <div v-else class="display-22">
            <p>כרגע לא נמצאו משרות רלוונטיות בחברת {{ companyName }}</p>
            <nuxt-link :to="`/companies`">
              מומלץ לחפש בחברות דומות אחרות
            </nuxt-link>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { isEmpty } from 'lodash';
import CompanyPageBase from '@/components/Company/CompanyPageBase';
import WorkersSayings from '@/components/Company/WorkersSayings';
import SeoOptimization from '@/components/mixins/SeoOptimization';

export default {
  extends: CompanyPageBase,
  mixins: [SeoOptimization],
  components: {
    WorkersSayings,
  },
  props: {
    seo: {
      type: Array,
      required: false,
      default: () => [],
    }
  },

  computed: {
    onTheMapText() {
      return this.companyName + ' ' + 'על המפה ';
    },

    latitude() {
      return this.lat ? this.lat : 32.279476;
    },

    longitude() {
      return this.lng ? this.lng : 34.86024;
    },
  },

  methods: {
    isEmptyArr(collection) {
      return isEmpty(collection) ? true : false;
    },
  },
};
</script>


<style lang="scss" scoped>
#TopBoardCompany {
  flex: 1;
}
.testimonials-hdr {
  position: relative;
  top: 60px;
  z-index: 5;
}

#description {
  text-align: right !important;
  height: auto;
}

.location {
  background: #f6f7f9;
}
.how-long {
  background: $primary;
}
</style>
